export default "__VITE_ASSET__a6b822bf__"